/* ════════════════════════════════════════════════════════════════
   THE PINE STRAW SHOPPE — shoppe.js
   Global interactions only. Section-specific behaviour (coverage
   calculator, product buy box) ships inside those sections.
   ES5 / vanilla, presence-guarded so it no-ops where unused.
   ════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  /* ── Mobile menu toggle ──────────────────────────────────── */
  function initMenu() {
    var toggle = document.querySelector('[data-menu-toggle]');
    var nav = document.querySelector('[data-mobile-nav]');
    if (!toggle || !nav) return;
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    // Close after tapping a link
    var links = nav.querySelectorAll('a');
    for (var i = 0; i < links.length; i++) {
      links[i].addEventListener('click', function () {
        nav.classList.remove('open');
        toggle.setAttribute('aria-expanded', 'false');
      });
    }
  }

  /* ── FAQ accordion ───────────────────────────────────────── */
  function initFaq() {
    var items = document.querySelectorAll('[data-faq-item]');
    if (!items.length) return;
    for (var i = 0; i < items.length; i++) {
      (function (item) {
        var q = item.querySelector('[data-faq-q]');
        if (!q) return;
        q.addEventListener('click', function () {
          var isOpen = item.classList.contains('open');
          // Close siblings within the same list for a tidy single-open feel
          var list = item.parentNode;
          var siblings = list.querySelectorAll('[data-faq-item]');
          for (var j = 0; j < siblings.length; j++) siblings[j].classList.remove('open');
          if (!isOpen) item.classList.add('open');
        });
      })(items[i]);
    }
  }

  /* ── Grid visibility: format filter × needle toggle ──────── */
  function applyGridVisibility() {
    var grid = document.querySelector('[data-product-grid]');
    if (!grid) return;
    var f = 'all';
    var fb = document.querySelector('[data-filter-bar] button.active');
    if (fb) f = fb.getAttribute('data-filter');
    var nb = document.querySelector('[data-needle-view].active');
    var n = nb ? nb.getAttribute('data-needle-view') : null;
    var cards = grid.querySelectorAll('[data-format]');
    for (var j = 0; j < cards.length; j++) {
      var fMatch = (f === 'all') || (cards[j].getAttribute('data-format') === f);
      var nMatch = !n || !cards[j].hasAttribute('data-needle') || (cards[j].getAttribute('data-needle') === n);
      cards[j].style.display = (fMatch && nMatch) ? '' : 'none';
    }
  }

  /* ── Product filter (Boxes / Pallets / All) ──────────────── */
  function initFilter() {
    var bar = document.querySelector('[data-filter-bar]');
    if (!bar) return;
    bar.addEventListener('click', function (e) {
      var btn = e.target.closest('button');
      if (!btn) return;
      var btns = bar.querySelectorAll('button');
      for (var i = 0; i < btns.length; i++) btns[i].classList.remove('active');
      btn.classList.add('active');
      applyGridVisibility();
    });
  }

  /* ── Needle toggle (Longleaf / Slash) ─────────────────────── */
  function initNeedleView() {
    var btns = document.querySelectorAll('[data-needle-view]');
    if (!btns.length) return;
    for (var i = 0; i < btns.length; i++) {
      btns[i].addEventListener('click', function (e) {
        var b = e.currentTarget;
        for (var j = 0; j < btns.length; j++) {
          btns[j].classList.remove('active');
          btns[j].setAttribute('aria-pressed', 'false');
        }
        b.classList.add('active');
        b.setAttribute('aria-pressed', 'true');
        applyGridVisibility();
      });
    }
    applyGridVisibility(); /* default view: longleaf only */
  }

  /* ── Delivery view toggle (res/com pallet pricing on grids) ── */
  var DELIVERY_DESC = {
    res: '<strong>Residential</strong> \u2014 liftgate truck with a scheduled delivery appointment and curbside drop-off. The right choice for homes and driveways.',
    com: '<strong>Commercial</strong> \u2014 requires a loading dock or forklift to unload. Prices shown are commercial delivery.'
  };

  function currentDeliveryMode() {
    var btns = document.querySelectorAll('[data-delivery-view]');
    for (var i = 0; i < btns.length; i++) {
      if (btns[i].classList.contains('active')) return btns[i].getAttribute('data-delivery-view');
    }
    return 'res';
  }

  function initDeliveryView() {
    var btns = document.querySelectorAll('[data-delivery-view]');
    if (!btns.length) return;
    function apply(mode) {
      for (var i = 0; i < btns.length; i++) {
        var on = btns[i].getAttribute('data-delivery-view') === mode;
        btns[i].classList.toggle('active', on);
        btns[i].setAttribute('aria-pressed', on ? 'true' : 'false');
      }
      var amts = document.querySelectorAll('[data-price-res]');
      for (var j = 0; j < amts.length; j++) {
        amts[j].textContent = amts[j].getAttribute(mode === 'com' ? 'data-price-com' : 'data-price-res');
      }
      var tags = document.querySelectorAll('[data-dock-tag]');
      for (var k = 0; k < tags.length; k++) tags[k].hidden = (mode !== 'com');
      var desc = document.querySelector('[data-delivery-desc]');
      if (desc) {
        desc.innerHTML = DELIVERY_DESC[mode];
        desc.classList.toggle('dd-com', mode === 'com');
      }
    }
    for (var i = 0; i < btns.length; i++) {
      btns[i].addEventListener('click', function (e) {
        apply(e.currentTarget.getAttribute('data-delivery-view'));
      });
    }
  }

  /* ── Grid quick-add (Add to Cart on product cards) ─────────── */
  function initQuickAdd() {
    var buttons = document.querySelectorAll('[data-add-to-cart]');
    if (!buttons.length) return;
    var modal = document.getElementById('gridCommModal');
    var pendingBtn = null;

    function updateCartCount(n) {
      var cartBtn = document.querySelector('.cart-btn');
      if (!cartBtn) return;
      var c = cartBtn.querySelector('.cart-count');
      if (!c) {
        c = document.createElement('span');
        c.className = 'cart-count';
        cartBtn.appendChild(c);
      }
      c.textContent = n;
    }

    function addItem(vid, btn) {
      btn.disabled = true;
      btn.textContent = 'Adding\u2026';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(vid, 10), quantity: 1, properties: { 'Ship-out date': 'Earliest available' } }] })
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return fetch('/cart.js');
      }).then(function (r) { return r.json(); }).then(function (cart) {
        updateCartCount(cart.item_count);
        btn.textContent = 'Added \u2713';
        setTimeout(function () { btn.disabled = false; btn.textContent = 'Add to Cart'; }, 1600);
      }).catch(function () {
        btn.disabled = false;
        btn.textContent = 'Add to Cart';
        alert("Couldn't add to cart \u2014 please try the product page.");
      });
    }

    for (var i = 0; i < buttons.length; i++) {
      buttons[i].addEventListener('click', function (e) {
        var btn = e.currentTarget;
        var isPallet = btn.getAttribute('data-is-pallet') === 'true';
        if (isPallet && currentDeliveryMode() === 'com' && modal) {
          pendingBtn = btn;
          modal.hidden = false;
          return;
        }
        addItem(btn.getAttribute(isPallet && currentDeliveryMode() === 'com' ? 'data-vid-com' : 'data-vid-res'), btn);
      });
    }

    if (modal) {
      document.getElementById('gridCommConfirm').addEventListener('click', function () {
        modal.hidden = true;
        if (pendingBtn) addItem(pendingBtn.getAttribute('data-vid-com'), pendingBtn);
        pendingBtn = null;
      });
      function cancelModal() { modal.hidden = true; pendingBtn = null; }
      document.getElementById('gridCommCancel').addEventListener('click', cancelModal);
      modal.addEventListener('click', function (e) { if (e.target === modal) cancelModal(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) cancelModal(); });
    }
  }

  function init() { initMenu(); initFaq(); initFilter(); initNeedleView(); initDeliveryView(); initQuickAdd(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
